import React, {PureComponent} from 'react'
import styled from 'styled-components'
import { Formik, Field } from 'formik'
// import * as Cookies from 'js-cookie'
import { Icon } from '../components'
import PinInputField from '../components/PinInputField'
import { toast } from 'react-toastify'
import * as _ from 'lodash'
import axios from 'axios' 
import {API_URL} from '../constants'
import CryptoJS from 'crypto-js';

const encryptData=(data,iv,key)=>{
  let encryptedString 
  if(typeof data=="string"){
    data=data.slice();
  encryptedString = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
});
  }
 else{
 encryptedString = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
});  
 }
return encryptedString.toString();
}


const hashSHA512 = (password, salt) => {
  const salted = password + salt;
  const hash = CryptoJS.SHA512(salted).toString(CryptoJS.enc.Hex);
  return hash;
};




const encryptData1 = (data, IVV2, key) => {
  const hashedKey = CryptoJS.SHA512(key).toString(CryptoJS.enc.Hex);
  const aesKey = CryptoJS.enc.Hex.parse(hashedKey.slice(0, 64)); // 256-bit key

  // Ensure IV is 16 bytes (32 hex chars)
  const iv = IVV2
    ? CryptoJS.enc.Hex.parse(IVV2.padEnd(32, '0'))
    : CryptoJS.lib.WordArray.random(16);

  const encrypted = CryptoJS.AES.encrypt(data, aesKey, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return {
    iv: iv.toString(CryptoJS.enc.Hex),
    encryptedData: encrypted.ciphertext.toString(CryptoJS.enc.Hex),
  };
};


const decryptData = (encryptedHex, ivHex, key) => {
  const hashedKey = CryptoJS.SHA512(key).toString(CryptoJS.enc.Hex);
  const aesKey = CryptoJS.enc.Hex.parse(hashedKey.slice(0, 64));
  const iv = CryptoJS.enc.Hex.parse(ivHex);

  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: CryptoJS.enc.Hex.parse(encryptedHex) },
    aesKey,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  return decrypted.toString(CryptoJS.enc.Utf8);
};








const Container = styled.div`
  width: 100%;
  max-width: 500px;
  margin: auto;
  padding: 16px; 
  height: 100vh;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  & form{
    width: 100%;
  }
  & > *{
    position: relative;
    z-index: 999;
  }
  & > img{
    position: absolute;
    width: 100%;
    max-width: 500px;
    z-index: 0;
    opacity: 0.1
  }
`
const Title = styled.p`
  margin: 0px;
  padding: 10px 0 3px 0;
  width: 100%;
  text-align: left;
`
const PageTitle = styled.h2`
  color: #020266;
  text-align: center;
`

const Input = styled.input`
  border: 1px solid hsl(0,0%,80%);
  border-radius: 4px;
  width: 100%;
  padding: 10px;
  width: 100%;
`
const ButtonWrapper = styled.div`
  padding: 30px 15px 15px 15px;
  display: flex;
  justify-content: center;
  align-items: center;
`
const Button = styled.button`
  padding: 10px 45px;
  background: #020266;
  border: 1px solid #020266;
  border-radius: 4px;
  color: #fff;
`
const LoginTypeChange = styled.div`
  position:relative;
  color: #2d2dd4;
  font-weight: 600;
  font-size: 12px;
  align-items: center;
  justify-content: flex-end;
  display: flex;
  & span{
    padding-left:15px;
    cursor:pointer;
    font-size:10px;
    margin-top:7px;
  }
`


class Login extends PureComponent{
  state = {
    captchavalue: {},
    view:false,
    loginType:'otp',
    latitude:'',
    longitude:'',
    generatingPin:false

  }

  componentDidMount=async () => {
    try{
      const generatedUserPin = localStorage.getItem('userName')
        const { data: captchavalue } = await axios.get(`${API_URL}/users/Captcha`);
        let DecodedCaptcha=  Buffer.from(captchavalue.Captcha, 'base64').toString('ascii')
        this.setState({ captchavalue,DecodedCaptcha, isLoading: false,loginType: generatedUserPin ? 'pin' :'otp'  });
    }catch{
      toast.error('Network error')
    }

  //   if(navigator.geolocation){
  //     navigator.geolocation.getCurrentPosition((position)=> {
  //       const latitude = position.coords.latitude
  //       const longitude = position.coords.longitude
  //       // console.log('ajitlatitude--',latitude,'longitude---',longitude)
  //      // this.setState({latitude,longitude})
  //     })
  //   navigator.permissions && navigator.permissions.query({name: 'geolocation'})
  //   .then(function(PermissionStatus) {
  //       if (PermissionStatus.state === 'denied') {
  //           navigator.permissions.query({name:'geolocation', userVisibleOnly:true})
  //           alert('Need to location permission allow.')  
  //       } 
  //   })
  // }else{
  //   alert("Geolocation is not supported on your Browser/OS.");
  // }

    
  }

  handlecaptcha= async(type)=>{
    this.setState({dataFilterType:type, isLoading: true})
   // const {match}=this.props
    const { data: captchavalue } = await axios.get(`${API_URL}/users/Captcha`); 
    let DecodedCaptcha=  Buffer.from(captchavalue.Captcha, 'base64').toString('ascii')  
    this.setState({captchavalue,DecodedCaptcha, isLoading: false})
   }

   resendOtp=async(username)=>{
    await axios.post(`${API_URL}/users/usersverifySendOTP`, {username,type:'loginOTP'})
    .then((res) => {

      if (_.get(res, "data.otpRequired", false)) {
        toast.error(res.data.message);
      } else {
        toast.success(res.data.message);
      }
    }).catch((err) => {
        toast.error(err.response.data.message);  
    });
   }
 
   generatePin=async(data)=>{
    await axios.post(`${API_URL}/users/generatepin`, data)
    .then((res) => {
      // console.log('res------->',res )
      this.setState({generatingPin:false},()=>{
        toast.success(res.data.message);
        localStorage.setItem('userName', _.get(data,'userName'));
        window.location.reload()
      })

    }).catch((err) => {
      // console.log('err------->',err )
        this.setState({generatingPin:false},()=>{
          toast.error(err.response.data.message);  
        })
    });
   }
   

  render(){
    const {
      captchavalue,
      DecodedCaptcha,
      loginType,
      view,
      latitude,
      longitude,
      generatingPin
    } = this.state
    const generatedUserPin = localStorage.getItem('userName')

    return(
      <Container>
      <PageTitle>Login</PageTitle>
      {/* <Formik
      initialValues={{ email: '', password: '' }}
      onSubmit={this.handleFormSubmit}
    >
      {({
        values,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
      }) => (
        <form onSubmit={handleSubmit}>
        <Title>Email/Username</Title>
        <Input   
        autoComplete={'off'}
         name="email"
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.email}/>

        <Title>Password</Title>
        <Input
        type="password"
        name="password"
        autoComplete={'new-password'}
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.password}
        />

          <ButtonWrapper>
          <Button>Login</Button>
          </ButtonWrapper>
        </form>
      )}
    </Formik> */}

    
               <Formik
                enableReinitialize={true}
                initialValues={{
                  userName: generatedUserPin || '',
                  otp: "",
                  pin: "",
                  loginOtp: "",
                  loginType:loginType||'',
                  password: "",
                  userCaptcha:"",
                  captchavalue: "",
                  otpRequired:false,
                  isSubmitting:false
                }}
                onSubmit={async (input, { resetForm, setFieldValue }) => {
    
                  
                  var pass=input.password;//Message to Encrypt
                  var iv  = CryptoJS.enc.Base64.parse("");//giving empty initialization vector
                  // var key=CryptoJS.SHA256(input.userCaptcha);//hashing the key using SHA256
                  var key=CryptoJS.SHA256(_.get(input, "loginType")==='password' ?  input.userCaptcha : _.get(input, "loginType")+'Login');//hashing the key using SHA256
               
                //   if(navigator.geolocation){
                  
                //     navigator.geolocation.getCurrentPosition(async(position)=> {
                //       const latitude = position.coords.latitude
                //       const longitude = position.coords.longitude
                //       this.setState({latitude,longitude})
                //     })
                //   navigator.permissions && navigator.permissions.query({name: 'geolocation'})
                //   .then(function(PermissionStatus) {
                //       if (PermissionStatus.state === 'denied') {
                //           navigator.permissions.query({name:'geolocation', userVisibleOnly:true})
                //           alert('Need to location permission allow.') 
                //       } 
                //   })
                // }else{
            
                //   alert("Geolocation is not supported on your Browser/OS.");
                // }



                setFieldValue('isSubmitting',true)
                let data = {
                  email: input.userName,
                  password: encryptData(pass,iv,key),
                  captchavalue:captchavalue.Captcha,
                  otp: input.otp,
                  loginType:input.loginType,
                  userCaptcha: input.userCaptcha,
                  latitude:0,
                  longitude:0,
                  visitor:'yes',
                  _id:captchavalue._id
                };
               
                await axios
                .post(`${API_URL}/users/login`, data)
                .then(res => {
                  if(_.get(res,'data.otpRequired',false)){
                    setFieldValue('isSubmitting',false)
                    setFieldValue('otpRequired',true)
                  toast.error(res.data.message);
                  }else{
                
                    localStorage.setItem('userId', res.data.userId);
                    localStorage.setItem('userData', JSON.stringify(res.data.userData || []));
                    toast.success(res.data.message);
                    this.props.history.push("/");
                }
                })
                .catch(err => {
                  setFieldValue('isSubmitting',false)
                  toast.error(err.response.data.message);
                  this.handlecaptcha("captcha")
                  setFieldValue('userCaptcha','')
                });

               
          

                }}
              >
                {formikBag => {
                  // console.log(formikBag.values)
                  return (
                    <form
                      className="row"
                      onSubmit={event => {
                        event.preventDefault();
                        formikBag.validateForm().then(errors => {
                          const errKeys = Object.keys(errors);
                          if (errKeys.length > 0) {
                            const errMessage =
                              typeof errors[errKeys[0]] === "string"
                                ? errors[errKeys[0]]
                                : errors[errKeys[0]]["value"];
                            toast.error(errMessage, {
                              position: toast.POSITION.BOTTOM_CENTER
                            });
                            // alert(errMessage);
                            return null;
                          } else {
                            return formikBag.handleSubmit();
                          }
                        });
                      }}
                    >
                      {/* <div className="col-md-12 col-sm-12">
                        <Field name="userName">
                          {({ field, form }) => (
                            <Input
                              isRequiredIcon={true}
                              label="Email"
                              value={get(form.values, "userName", "")}
                              {...field}
                            />
                          )}
                        </Field>
                      </div> */}

               <Title>Email/Username</Title>
                <Field name="userName">
                  {({ field, form }) => (
                    <Input
                      {...field}
                      onBlur={(e)=>{
                        if(e.target.value && loginType!=='password'){
                           this.resendOtp(e.target.value)
                         }
                       }}
                    />
                  )}
                </Field>
                <LoginTypeChange>
                         {loginType!=='otp'? <span onClick={()=>{
                           formikBag.setFieldValue('password','')
                          this.setState({loginType:'otp'})
                          }}>Use OTP</span>:''}
                          {loginType!=='password'?<span onClick={()=>{
                            formikBag.setFieldValue('password','')
                            this.setState({loginType:'password'})
                            }}>Use Password</span>:''}
                          {loginType!=='pin'?<span onClick={()=>{
                            formikBag.setFieldValue('password','')
                            this.setState({loginType:'pin'})
                            }}>{generatedUserPin ? 'Use Pin' :'Generate Pin'}</span>:''}
                        </LoginTypeChange>

                   {loginType==='password' ?<> <Title>Password</Title>
                      <div style={{position:'relative'}}>
                            <Field name="password">
                          {({ field, form }) => (
                            <>
                            <Input
                              type={view ?'text' :"password"}
                              {...field}
                            />
                            <div 
                              style={{position:'absolute', right:10,top:8}}
                              onClick={()=>this.setState({view:!view})}  
                            >
                              <Icon icon={view ? 'eyeoff':'eye'}/>
                            </div>
                            </>
                          )}
                        </Field>
                        </div>
                  <table>
                    <tbody>
                    <tr>
                      <td>
                      <div className="col-md-4 col-sm-4" id="captcha" style={{fontStyle: 'italic', fontWeight: 'bold', fontSize: "2em", padding: 3, textDecoration: "line-through", color: "#a0a0a0" }}>{DecodedCaptcha}</div>
                         
                      </td>
                      <td>
                      <div className="col-md-2 col-sm-2" style={{paddingTop:12, color:'#000'}} onClick={() =>{
                            this.handlecaptcha("captcha")
                            formikBag.setFieldValue('userCaptcha','')
                            }}>
                           <Icon icon='refresh' width={30} height={30}/>
                        </div>
                      </td>
                      <td>
                      <div className="col-md-6 col-sm-6" style={{paddingTop:12}}>
                          <Field name="userCaptcha">
                            {({ field, form }) => (
                              <Input
                                isrequiredicon={'true'}
                                {...field}
                              />
                            )}
                          </Field>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table></>:''}
                      

										{_.get(formikBag.values,'otpRequired')	&& <div className="col-md-12 col-sm-12">
                        <Field name="otp">
                          {({ field, form }) => (
                            <Input
                              isRequiredIcon={true}
                              label="OTP"
                              {...field}
                            />
                          )}
                        </Field>
                      </div>}
                 

                    <ButtonWrapper 
                      style={loginType ==='pin' || loginType ==='otp' ? {opacity:0, height:0,padding:0, display:loginType ==='pin'?'none':'block'} : {}}
                    
                    >
                      <Button disabled={_.get(formikBag.values,'isSubmitting')}>Login</Button>
                    </ButtonWrapper>

                    {/* Generate Pin */}
                    { loginType==='pin' && !generatedUserPin ? <>
                      <div className="col-md-12 col-sm-12">
                          <PinInputField 
                            label='OTP'
                            isrequiredicon={'true'}
                            onComplete={(value, index)=>{
                              if(_.get(formikBag,'values.userName')){
                                formikBag.setFieldValue('otp',value)
                              }else{
                                toast.error('Please enter email or username.');
                              }
                            }}
                          />
                          {_.get(formikBag,'values.userName') ? <span 
                            style={{color:'#059e37', fontWeight:600, cursor:'pointer'}}
                            onClick={(e)=>{
                              if(_.get(formikBag,'values.userName') && loginType==='pin'){
                                 this.resendOtp(_.get(formikBag,'values.userName'))
                               }
                             }}
                            >Resend OTP</span>:''}
                        </div>

                        <div className="col-md-12 col-sm-12">
                          <PinInputField 
                            label='New Pin'
                            isrequiredicon={'true'}
                            onComplete={(value, index)=>{
                              if(_.get(formikBag,'values.userName')){
                                formikBag.setFieldValue('pin',value)
                              }else{
                                toast.error('Please enter email or username.');
                              }
                            }}
                          />
                        </div>

                        <Button
                          type="button"
                          variant="primary"
                          size="sm"
                          className='w-100 mt-4'
                          // style={loginType ==='pin' || loginType ==='otp' ? {opacity:0, display:loginType ==='pin'?'none':'block'} : {}}
                          disabled={generatingPin}
                          onClick={() => {
                            if(_.get(formikBag,'values.pin') && _.get(formikBag,'values.otp') && _.get(formikBag,'values.userName')){
                              this.setState({generatingPin:true},()=>{
                                this.generatePin(formikBag.values)
                              })
                            }else{
                              toast.error('All fileds required.');
                            }
                          }}
                        >
                          {generatingPin ? (
                            <i className={"fa fa-spinner fa-spin"}></i>
                          ) : (
                            "Generate Pin"
                          )}
                        </Button>

                        </>:''}
                      {/*End Generate Pin */}
                      {/*Login with Pin */}

                          {loginType==='pin' && generatedUserPin ?
                                <div className="col-md-12 col-sm-12">
                                <PinInputField 
                                  label='Pin'
                                  isrequiredicon={'true'}
                                  onComplete={(value, index)=>{
                                    if(_.get(formikBag,'values.userName')){
                                      formikBag.setFieldValue('password',value)
                                      formikBag.handleSubmit()
                                    }else{
                                      toast.error('Please enter email or username.');
                                    }
                                  }}
                                />
                              </div>:''
                          }
                      {/*End Login with Pin */}
                      {/*OTP */}
                      {loginType==='otp' ?<div className="col-md-12 col-sm-12">
                          <PinInputField 
                            label='OTP'
                            isrequiredicon={'true'}
                            onComplete={(value, index)=>{
                              // console.log('-------->',value, index)
                              if(_.get(formikBag,'values.userName')){
                                formikBag.setFieldValue('password',value)
                                formikBag.handleSubmit()
                              }else{
                                toast.error('Please enter email or username.');
                              }
                            }}
                          />
                          {_.get(formikBag,'values.userName') ? <span 
                            style={{color:'#059e37', fontWeight:600, cursor:'pointer'}}
                            onClick={(e)=>{
                              if(_.get(formikBag,'values.userName') && (loginType==='otp' || loginType==='pin')){
                                 this.resendOtp(_.get(formikBag,'values.userName'))
                               }
                             }}
                            >Resend OTP</span>:''}
                        </div>:''}
                      {/*End OTP */}

                    </form>
                  );
                }}
              </Formik>
       
       <img src={require('../static/pmay-g-logo.png')} alt='log'/>

      </Container>
    )
  }
}

export {Login}